import React, { useRef } from 'react'
import { Popper, Paper, Typography, Button, Box } from '@material-ui/core'

function UpdateProfileReminder({ anchorEl, open, onDismiss }) {
  const arrowRef = useRef(null)

  const returnTo = () =>
    '?' +
    new URLSearchParams({
      return_to: `${location.pathname}${location.search}`,
    }).toString()

  const handleProfile = () => {
    window.location.href = `/profile${returnTo()}`
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement='bottom-end'
      style={{ zIndex: 1100, boxShadow: 'none' }}
      popperOptions={{
        modifiers: {
          arrow: {
            enabled: true,
            element: arrowRef.current,
          },
        },
      }}
    >
      <div
        ref={arrowRef}
        style={{
          position: 'absolute',
          width: 37,
          height: 37,
          backgroundColor: 'white',
          transform: 'rotate(45deg)',
          border: '1px solid #ccc',
          zIndex: 900,
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 19,
          width: 14,
          height: 7,
          backgroundColor: 'white',
          zIndex: 1001,
        }}
      />

      <Paper
        elevation={3}
        style={{
          position: 'relative',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          padding: '12px 16px',
          maxWidth: 300,
          boxShadow: 'none',
          border: ' 1px solid #ccc',
          zIndex: 1000,
        }}
      >
        <Typography variant='body2' gutterBottom>
          Update your phone number to receive WhatsApp notifications for order updates.
        </Typography>
        <Box display='flex' justifyContent='flex-end' mt={2} gridColumnGap={10}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            size='small'
            onClick={handleProfile}
          >
            Update Now
          </Button>
          <Button size='small' variant='contained' onClick={onDismiss} color='secondary'>
            Dismiss
          </Button>
        </Box>
      </Paper>
    </Popper>
  )
}

export default UpdateProfileReminder
